import React from 'react';
import LoadingList from './LoadingList';

const Loading = (props) => {
  return (
    <div className={`Loading ${props.className}`}>
      <div className={`${props.type}`}></div>
      <LoadingList />
      
    </div>
  );
}


export default Loading;